import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import firebaseService from '../services/firebaseService';
import authService from '../services/authService';
import Navigation from './Navigation';

function MySubmissions() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadSubmissions();
  }, []);

  const loadSubmissions = async () => {
    try {
      setLoading(true);
      setError('');
      const user = authService.getCurrentUser();
      const userId = user?.id || user?.uid || user?.email;
      
      if (!userId) {
        setError('User not found. Please login again.');
        return;
      }

      const submissionsList = await firebaseService.getSubmissionsByUser(userId);
      setSubmissions(submissionsList);
    } catch (err) {
      setError('Failed to load submissions. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToForms = () => {
    navigate('/forms');
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  const formatSubmissionData = (data) => {
    if (!data || typeof data !== 'object') return 'No data';
    
    return Object.entries(data)
      .filter(([key]) => !key.startsWith('_')) // Filter out internal fields
      .map(([key, value]) => {
        if (typeof value === 'object' && value !== null) {
          return `${key}: ${JSON.stringify(value)}`;
        }
        return `${key}: ${value}`;
      })
      .join(', ');
  };

  return (
    <div className="submissions-container">
      <Navigation />
      
      <div className="content-wrapper">
      {loading && (
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading submissions...</p>
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
          <button onClick={loadSubmissions} className="btn-retry">
            Retry
          </button>
        </div>
      )}

      {!loading && !error && submissions.length === 0 && (
        <div className="no-submissions">
          <p>You haven't submitted any forms yet.</p>
          <button onClick={handleBackToForms} className="btn-primary">
            Browse Available Forms
          </button>
        </div>
      )}

      {!loading && !error && submissions.length > 0 && (
        <div className="submissions-list">
          {submissions.map((submission) => (
            <div key={submission.id} className="submission-card">
              <div className="submission-header">
                <h3>{submission.formName || 'Untitled Form'}</h3>
                <span className="submission-date">
                  {formatDate(submission.submittedAt)}
                </span>
              </div>
              <div className="submission-content">
                <p className="submission-preview">
                  {formatSubmissionData(submission.submission)}
                </p>
              </div>
              <div className="submission-footer">
                <span className="badge">Form ID: {submission.formId}</span>
              </div>
            </div>
          ))}
        </div>
      )}
      </div>
    </div>
  );
}

export default MySubmissions;
